import React, { useState } from "react";
import ModalVideo from "react-modal-video";

const CareerInner= () => {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      {/* service area start */}
      <div className='service-area pd-top-120 pd-bottom-120'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-12'>
              <div className='service-details-wrap'>
                <h2>CAREERS</h2>
                <p>
                We at NECC value employee relationships and focus on career growth and are committed to invest on talent. NECC grooms young minds and is the preferred place for career in the Indian logistic industry.We believes in fostering excellent employee culture, with focus on individual development.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* service area end */}
      <ModalVideo
        channel='youtube'
        autoplay
        isOpen={isOpen}
        videoId='XM6kTQPzzpQ'
        onClose={() => setOpen(false)}
       />
    </>
  );
};

export default CareerInner;
